// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.background {
  position: relative;
  background-blend-mode: color, saturation;
  flex-shrink: 0;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-container {
  background: white;
  font-size: 15px;
  width: 600px;
  min-height: 90vh;
  margin-bottom: 5vh;
  margin-top: 5vh;
  padding: 20px;
  padding-top: 50px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.main-logo {
  max-width: 300px;
  margin: 0 auto;
  display: block;
}

@media (max-width: 600px) {
  .background {
    display: initial;
  }
  .login-container {
    width: 100%;
    margin: 0;
    box-shadow: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/authentication/logout/logout.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,iBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;EACA,4CAAA;AACF;;AAIA;EACE,gBAAA;EACA,cAAA;EACA,cAAA;AADF;;AAIA;EACE;IACE,gBAAA;EADF;EAIA;IACE,WAAA;IACA,SAAA;IACA,gBAAA;EAFF;AACF","sourcesContent":[".background {\n  position: relative;\n  background-blend-mode: color, saturation;\n  flex-shrink: 0;\n  background-repeat: no-repeat;\n  background-size: cover;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.login-container {\n  background: white;\n  font-size: 15px;\n  width: 600px;\n  min-height: 90vh;\n  margin-bottom: 5vh;\n  margin-top: 5vh;\n  padding: 20px;\n  padding-top: 50px;\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n}\n\n\n\n.main-logo {\n  max-width: 300px;\n  margin: 0 auto;\n  display: block;\n}\n\n@media(max-width: 600px) {\n  .background {\n    display: initial;\n  }\n\n  .login-container {\n    width: 100%;\n    margin: 0;\n    box-shadow: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
